import type { FC } from 'react';
import { Box, Typography } from '@mui/material';

import { styles } from './index.styles';

const ChartBackground: FC = () => (
  <Box sx={styles.chartBackgroundWrapper}>
    <Box sx={styles.chartBackground}>
      {[...Array(10).keys()].map((labelY, i) => (
        <Box key={i} sx={styles.valueIndicator}>
          <Typography sx={styles.labelY}>{`${100 - labelY * 10}%`}</Typography>
        </Box>
      ))}
      <Box sx={[styles.valueIndicator, { height: '0' }]}>
        <Typography sx={styles.labelY}>0%</Typography>
      </Box>
    </Box>
  </Box>
);

export default ChartBackground;
